import React, {useContext} from 'react';

import {OrderContext} from 'views/order/OrderForm';

import {RadioButton} from 'views/FormElements';


const styles = {
    extraCostInfo: {color: '#2e292b', marginTop: '10px', background: '#dfdfdf', padding: '5px 10px', borderBottom: "2px solid #f8931c", fontSize: '95%'}
}

const PaymentPreferenceInput = ({prepaymentRequired}) => {
    const {values} = useContext(OrderContext);
    
    return <React.Fragment>
            
            {
                prepaymentRequired &&
                <div style={styles.extraCostInfo}>
                    <b style={{color: '#f49600'}}>Pre-Payment Required.</b> Select the payment option you can use to make the payment.
                </div>
            }
                
            <div className='flexRow'>
                {
                    !prepaymentRequired &&

                    <RadioButton style={{flexGrow: '1'}} name="paymentPreference" value={"COD"} 
                        label={<span style={{color: '#596161'}}>Cash On Delivery</span>} 
                        checked={values.paymentPreference === "COD"} />
                }

                <RadioButton style={{flexGrow: '1'}} name="paymentPreference" value={"ESEWA"} 
                        label={<span style={{color: '#596161'}}>eSewa</span>} 
                        checked={values.paymentPreference === "ESEWA"} />

                <RadioButton style={{flexGrow: '1'}} name="paymentPreference" value={"QR_CODE_SCAN"} 
                            label={<span style={{color: '#596161'}}>QR Code Scan</span>} 
                            checked={values.paymentPreference === "QR_CODE_SCAN"} />

                {/* <RadioButton style={{flexGrow: '1'}} name="paymentPreference" value={"VISA_MASTER"} 
                            label={<span style={{color: '#596161'}}>Credit/Debit Card</span>} 
                            checked={values.paymentPreference === "VISA_MASTER"} /> */}

                <RadioButton style={{flexGrow: '1'}} name="paymentPreference" value={"BANK_TRANSER"} 
                            label={<span style={{color: '#596161'}}>Bank Transfer</span>} 
                            checked={values.paymentPreference === "BANK_TRANSER"} />
            </div>
    </React.Fragment>
}


export default PaymentPreferenceInput;


// WEBPACK FOOTER //
// ./src/views/order/input/PaymentPreferenceInput.js